<div class="d-flex flex-column gap-1 p-1">
  <a class="link_normal" target="_blank" (click)="$event.stopPropagation();" [href]="goPage(data.row.order.id)"> {{ mapDescription[data.row.order.id] || ''+data.row.order.id }} </a>
</div>

